export default __webpack_public_path__ + "static/media/liked.80db1bcb.svg";